import { Injectable } from '@angular/core';
import {
    ApolloGetSchoolUserDetailsGQL,
    ApolloSearchSchoolAccountsGQL,
    handleQueryResult,
} from '@lib/frontend-shared-data-gql-operations';
import { map, Observable } from 'rxjs';
import {
    PaginatedSearchCriteria,
    PaginatedSearchResult,
    Uuid,
} from '@lib/shared-interface-utility-types';
import { SchoolAccount, SchoolUserDetails } from '@lib/shared-interface-school-account';
import { Apollo } from 'apollo-angular';

@Injectable({ providedIn: 'root' })
export class SchoolAccountService {
    public constructor(
        private readonly apollo: Apollo,
        private readonly searchSchoolAccountsGql: ApolloSearchSchoolAccountsGQL,
        private readonly getSchoolUserDetails: ApolloGetSchoolUserDetailsGQL,
    ) {}

    public refetchSearch() {
        return this.apollo.client.refetchQueries({
            include: [this.searchSchoolAccountsGql.document],
        });
    }

    public search(
        searchCriteria: PaginatedSearchCriteria,
    ): Observable<PaginatedSearchResult<SchoolAccount>> {
        return this.searchSchoolAccountsGql.watch({ searchCriteria }).valueChanges.pipe(
            handleQueryResult(),
            map((data) => data.schoolAccounts),
        );
    }

    public findById(id: Uuid): Observable<SchoolUserDetails | undefined> {
        return this.getSchoolUserDetails.watch({ id }).valueChanges.pipe(
            handleQueryResult(),
            map((data) => data.schoolUserDetails),
        );
    }
}
